import { Button, Grid, makeStyles } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import DocumentPreview from '../../../components/DocumentPreview';
import DataTable from '../../../toolkit/DataTable/DataTable';
import ListDataProvider from '../../../toolkit/mobx-connectors/ListDataProvider';
import axios from '../../../utils/axios';
import createParams from '../../../utils/tables-params';
import importadoresConfig from './ImportadorConfig';

const useStyles = makeStyles(theme => ({
  container: {
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  img: {
    width: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100px'
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.short
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: theme.spacing(5),
      padding: theme.spacing(2),
      paddingTop: theme.spacing(4)
    }
  },
  tableCellAction: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  button: {
    margin: 0,
    textDecoration: 'none',
    marginLeft: theme.spacing(1)
  },
  addButon: {
    padding: '15px'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },

  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  cardStyle: {
    borderRadius: '4px 4px 0px 0px'
  }
}));

const ImportadorList = props => {
  const { gridProps } = props;
  const { enqueueSnackbar } = props;
  const classes = useStyles();
  const history = useHistory();
  const [pdfPreview, setPdfPreview] = useState();
  const classComponentRef = useRef(null);

  const onAgregar = () => {
    history.push('/importadores/edit/');
  };

  const onView = importador => {
    history.push(`/importadores/view/${importador.id}`);
  };

  const onEdit = importador => {
    history.push(`/importadores/edit/${importador.id}`);
  };

  const onDeactivate = async ({ id }) => {
    try {
      try {
        await axios.post(`importador/desactivar/${id}`);
        enqueueSnackbar('Activado/Desactivado correctamente', {
          variant: 'success'
        });
        classComponentRef.current.reload();
        // onReloadTable();
        // history.push('/personas');
      } catch (err) {
        console.log('err', err);
        enqueueSnackbar(
          err?.response?.data?.message ||
            'Error al intentar activado/desactivado',
          {
            variant: 'error'
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onDelete = async ({ id }) => {
    try {
      try {
        await axios.post(`importador/eliminar/${id}`);
        enqueueSnackbar('Eliminado correctamente', { variant: 'success' });
        classComponentRef.current.reload();
        // onReloadTable();
        // history.push('/personas');
      } catch (err) {
        console.log('err', err);
        enqueueSnackbar(
          err?.response?.data?.message || 'Error al intentar eliminar',
          {
            variant: 'error'
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const configuraciones = importadoresConfig({
    classes,
    enqueueSnackbar,
    onView,
    onEdit,
    onDelete,
    onDeactivate
  });
  const dataset = 'importadorList';

  const { datosConfig } = configuraciones[dataset];
  const { datosSettings } = configuraciones[dataset];

  const onReloadTable = () => {
    const settings = datosSettings;
    const params = createParams({ ...props.importadores.list, settings });
    axios
      .get(datosConfig.servicio, {
        data: {},
        params
      })
      .then(resp => {
        return props.importadores.list.dataLoaded(resp.data.data, {
          currentPage: resp.data.meta.currentPage - 1,
          pageSize: resp.data.meta.pageSize,
          itemsCount: resp.data.meta.total
        });
      })
      .catch(() => {
        enqueueSnackbar('Error al obtener los datos', 'error');
      });
  };

  return (
    <>
      <Grid container {...gridProps}>
        <ListDataProvider
          listStore={props.importadores.list}
          render={listProps => (
            <DataTable
              ref={classComponentRef}
              title={'Listado de importadores'}
              settings={datosSettings}
              onReloadTable={() => onReloadTable()}
              fileName={datosConfig.servicio}
              toolbarActionsEnd={[
                <Button
                  variant="outlined"
                  key="agregar"
                  color="primary"
                  className={classes.button}
                  startIcon={<Add />}
                  onClick={onAgregar}
                >
                  Agregar
                </Button>
              ]}
              {...listProps}
            />
          )}
        />
        {pdfPreview && (
          <DocumentPreview
            title={pdfPreview.title}
            file={pdfPreview.url}
            onClose={() => {
              setPdfPreview();
            }}
          />
        )}
      </Grid>
    </>
  );
};

export default inject('importadores')(observer(withSnackbar(ImportadorList)));
